"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PresentationControlPageInput = require("./PresentationControlPageInput.styled");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var PresentationControlPageInput = function PresentationControlPageInput(_ref) {
  var hasError = _ref.hasError,
    inputValue = _ref.inputValue,
    onChange = _ref.onChange,
    onKeyPress = _ref.onKeyPress,
    numPages = _ref.numPages,
    showInputForm = _ref.showInputForm,
    _ref$isSpeaker = _ref.isSpeaker,
    isSpeaker = _ref$isSpeaker === void 0 ? false : _ref$isSpeaker;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isSpeaker && /*#__PURE__*/_react["default"].createElement("span", null, "On stage:"), hasError ? /*#__PURE__*/_react["default"].createElement(_PresentationControlPageInput.StyledFontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faTriangleExclamation,
    color: "#DE2F1B",
    "data-testid": "page-number-input-error"
  }) : /*#__PURE__*/_react["default"].createElement(_PresentationControlPageInput.StyledPlaceholderInputError, null), /*#__PURE__*/_react["default"].createElement(_PresentationControlPageInput.StyledPageInput, {
    $hasError: hasError,
    onChange: onChange,
    type: "text",
    value: inputValue,
    onKeyPress: onKeyPress,
    readOnly: !showInputForm
  }), "of ".concat(numPages));
};
PresentationControlPageInput.propTypes = {
  hasError: _propTypes["default"].bool.isRequired,
  inputValue: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onKeyPress: _propTypes["default"].func.isRequired,
  numPages: _propTypes["default"].number.isRequired,
  showInputForm: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = PresentationControlPageInput;